import { Form } from 'antd';
import { noop } from 'lodash-es';
import { createContext, useContext, useState } from 'react';

import { extractValueFromEvent } from '../components/forms/formHelpers';
import { FormItemSearchFlat } from '../components/forms/searchFormElements';
import { useAccounts } from '../hooks/data/auth';

export const FreeTextJobSearchContext = createContext({
  value: '',
  setValue: noop,
  searchActive: false,
  setSearchActive: noop,
});

export function useFreeTextJobSearch() {
  const [value, setValue] = useState();
  const [searchActive, setSearchActive] = useState(false);

  return { value, setValue, searchActive, setSearchActive };
}

// Supports search by job number or HAWB/BOL
export function FreeTextJobSearch({ className }) {
  const { isQuoteEnabled } = useAccounts();
  const { value, setValue, setSearchActive } = useContext(
    FreeTextJobSearchContext
  );
  const [tmpValue, setTmpValue] = useState(value);
  return (
    <Form component={false}>
      <FormItemSearchFlat
        className={className}
        onSearch={val => setValue(val?.trim())}
        onCancel={() => {
          setValue('');
          setSearchActive(false);
          setTmpValue('');
        }}
        placeholderId={
          isQuoteEnabled
            ? 'monitor.search.quote.placeholder'
            : 'monitor.search.placeholder'
        }
        formItemComponentProps={{
          value: tmpValue,
          onChange: e => setTmpValue(extractValueFromEvent(e)),
          autoFocus: true,
        }}
      />
    </Form>
  );
}
